import { updateUnitInfo } from "@/service/unit";
export default {
  name: "UpdateUnitWebsite",
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    },
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      modal: {
        visible: false,
        loading: false
      },
      formObj: {
        website: ""
      },
      ruleCustom: {
        website: [{
          pattern: /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/,
          message: $t("26m0zba", "请输入正确的企业域名")
        }]
      }
    };
  },
  watch: {
    visible(val) {
      val && this.init();
      this.modal.visible = val;
    }
  },
  methods: {
    /* 不显示弹窗 */
    clean() {
      this.$emit("close");
      this.$refs["formCustom"].resetFields();
      this.formObj.website = "";
    },
    init() {
      this.formObj.website = this.item.website;
    },
    /* 提交事件 */
    onCommit() {
      /* 验证 */
      this.$refs["formCustom"].validate(async valid => {
        if (valid) {
          this.modal.loading = true;
          const params = {
            website: this.formObj.website
          };
          let res = await updateUnitInfo(params);
          if (res.data && res.data.result === 0) {
            this.$Message.success($t("d1spvi4", "操作成功"));
            this.$emit("update");
            this.clean();
          }
          this.modal.loading = false;
        }
      });
    }
  }
};